import React from "react";

export const PositiveChangeIcon = ({ ...props }) => {
  return (
    <svg
      y={18}
      x={48}
      width="6"
      height="3"
      viewBox="0 0 6 3"
      fill="none"
      {...props}
    >
      <path d="M6 3L3 0L0 3H6Z" fill="#13C997" />
    </svg>
  );
};
